import { toast } from 'react-toastify';
import useSWR from 'swr';
import api from '../services/api';
import { TIPOEXAME_SWR_KEY } from './clearCache';

const EMPTY_TIPOEXAME = [];

const fetchTipoExame = async () => {
  const result = await api.get('tipoexame');
  return result.data || EMPTY_TIPOEXAME;
};

const useTipoExame = () => {
  const { data: tipoexame = EMPTY_TIPOEXAME } = useSWR(
    TIPOEXAME_SWR_KEY,
    fetchTipoExame,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      onError: error => {
        toast.error(
          error?.response?.data?.error || 'Erro ao carregar tipos de exame!'
        );
      },
    }
  );

  return { tipoexame };
};

export default useTipoExame;
